import { Table } from "antd";
import { ColumnsType } from "antd/lib/table";
import { Pencil, Trash2 } from "lucide-react";
import { SupplierEntity } from "../../entitys";
import { Actions } from "../Actions/Actions";
import styles from "../styles.module.scss";
import { supplierData, SupplierRow } from "./utils";

interface SuppliersTableProps {
  onEdit: (shipment: SupplierEntity) => void;
  onDelete: (shipment: SupplierEntity) => void;
}

const SuppliersTable: React.FC<SuppliersTableProps> = ({
  onEdit,
  onDelete,
}) => {
  const supplierColumns: ColumnsType<SupplierRow> = [
    { title: "Name", dataIndex: "name", key: "name" },
    {
      title: "Address",
      key: "address",
      render: (_, r) => (
        <>
          <div>{r.addressLine1}</div>
          <div style={{ color: "#A6A7A8" }}>{r.addressLine2}</div>
        </>
      ),
    },
    {
      title: "Default MOQ",
      dataIndex: "defaultMOQ",
      key: "moq",
      align: "right",
    },
    {
      title: "Default MSQ",
      dataIndex: "defaultMSQ",
      key: "msq",
      align: "right",
    },
    {
      title: "Default Lead time",
      dataIndex: "defaultLeadTime",
      key: "lead",
      align: "right",
    },
    {
      title: "ASINs",
      dataIndex: "asins",
      key: "asins",
      render: (arr: string[]) =>
        arr.map((a) => (
          <span
            key={a}
            style={{
              display: "inline-block",
              background: "#2E2E2E",
              padding: "2px 6px",
              borderRadius: 4,
              marginRight: 4,
              marginBottom: 2,
              fontSize: 12,
            }}
          >
            {a}
          </span>
        )),
    },
    {
      title: "Actions",
      key: "actions",
      fixed: "right",
      width: 150,
      render: (_: unknown, row: SupplierRow) => (
        <Actions
          record={row}
          actions={[
            {
              icon: <Pencil />,
              onClick: (r) =>
                onEdit({
                  supplierId: r.key,
                  name: r.name,
                  country: r.addressLine1,
                  address: `${r.addressLine1} ${r.addressLine2}`.trim(),
                  defaultMoq: r.defaultMoq,
                  defaultMsq: r.defaultMsq,
                  defaultLeadTime: r.defaultLeadTime,
                }),
            },
            {
              icon: <Trash2 />,
              onClick: (r) => onDelete(r as unknown as SupplierEntity),
            },
          ]}
        />
      ),
    },
  ];
  return (
    <Table
      columns={supplierColumns}
      dataSource={supplierData}
      pagination={{ pageSize: 10 }}
      rowKey="key"
      scroll={{ x: 100 }}
      className={styles.table}
    />
  );
};

export default SuppliersTable;
